module.exports = __webpack_public_path__ + "img/governance-banner2.05402e83.png";